export const languages = [
    { code: "en", name: 'English' },
    { code: "kn", name: 'ಕನ್ನಡ' },
    { code: "hi", name: 'हिंदी' },
    { code: "pa", name: 'ਪੰਜਾਬੀ' },
    { code: "ta", name: 'தமிழ்' },
    { code: "te", name: 'తెలుగు' }
]